// src/components/Notifications.jsx
import { useNotifications } from 'providers/notifications';
import React, { useEffect, useRef, useState } from 'react';
import { Bell } from 'react-feather';

export const Notifications = ({ onClick }) => {
  const { notifications, markAllRead } = useNotifications();
  const count = notifications?.length || 0;

  const [animate, setAnimate] = useState(false);
  const prevCount = useRef(count);

  // Sound reference
  const soundRef = useRef(null);

  useEffect(() => {
    // Preload audio on mount
    soundRef.current = new Audio('/sounds/trip-alert.wav');
  }, []);

  useEffect(() => {
    const previous = prevCount.current;

    // Detect NEW notifications
    if (count > previous) {
      // Play sound
      if (soundRef.current) {
        soundRef.current.currentTime = 0;
        soundRef.current.play().catch(() => {});
      }

      // Trigger bump animation
      setAnimate(true);
      setTimeout(() => setAnimate(false), 300);
    }

    prevCount.current = count;
  }, [count]);

  const handleClick = () => {
    // Reset count to zero since user viewed notifications
    markAllRead?.();

    // Trigger any external click handler (e.g., open panel)
    onClick?.();
  };

  return (
    <div
      onClick={handleClick}
      className="relative cursor-pointer inline-flex items-center justify-center"
    >
      <Bell className="text-white" size={22} />

      {count > 0 && (
        <span
          className={`absolute -top-1 -right-1 bg-red-600 text-white text-xs font-semibold rounded-full px-1.5 py-0.5
          transition-transform duration-300 ${animate ? 'scale-125' : 'scale-100'}`}
        >
          {count > 99 ? '99+' : count}
        </span>
      )}
    </div>
  );
};
